const Alert = () => {
    return {
        MuiAlertTitle: {
            styleOverrides: {
                root: { fontWeight: 600, fontSize: '0.875rem', lineHeight: '1.25rem' }
            }
        }
    }
}

export default Alert
